import { makeStyles } from '@material-ui/core/styles';

const textDecoration = {
  textDecoration: 'none',
  color: 'inherit'
};

export const styles = makeStyles((theme) => ({
  container_nav_icon: {
    display: 'none',
    [theme.breakpoints.down(990)]: {
      display: 'flex',
      flexGrow: 1,
      alignItems: 'center',
      justifyContent: 'space-between'
    }
  },
  card_user: {
    height: '167px',
    backgroundColor: '#FFFFFF',
    boxShadow: 'none'
  },
  card_content: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end'
  },
  list: {
    width: 250
  },
  list_item: {
    backgroundColor: theme.palette.background.default + ' !important'
  },
  list_icon: {
    minWidth: '26px',
    '& > svg': {
      fontSize: '1.4rem'
    }
  },
  list_text: {
    color: ' rgba(0,0,0,0.60);'
  },
  fullList: {
    width: 'auto'
  },
  drawer: {
    '& > div': {
      zIndex: 0
    }
  },
  noDecoration: {
    textDecoration,
    '&:focus': textDecoration,
    '&:hover': textDecoration,
    '&:visited': textDecoration,
    '&:link': textDecoration,
    '&:active': textDecoration
  },
  logo: {
    height: '23px'
  },
  container_user: {
    display: 'flex'
  }
}));
